import { Component, Injector, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { UiFormParent } from 'src/common/components/form/form';
import { UiFormComponent } from 'src/common/components/form/form.component';
import { FullscreenDialogComponent } from '../fullscreen-dialog/fullscreen-dialog.component';

@Component({
  templateUrl: './form-only-dialog.component.html',
})
export class FormOnlyDialogComponent extends FullscreenDialogComponent implements OnInit, OnDestroy {

  @ViewChild(UiFormComponent) uiFormComponent: UiFormComponent;

  public formOnlyInjector: Injector;
  public isDirty: boolean = false;

  public ngOnInit(): void {
    this.formOnlyInjector = Injector.create([
      {
        provide: UiFormParent,
        useFactory: () => this.injector.get(FormOnlyDialogComponent),
        deps: [],
      },
      {
        provide: MAT_DIALOG_DATA,
        useValue: this.data,
      }
    ], this.associationController.injector);
  }

  ngOnDestroy(): void {
    super.ngOnDestroy();
    this.associationController.cleanupAssociationModal();
  }

  public isSubmitDisabled(): boolean {
    if (this.uiFormComponent) {
      return !((this.uiFormComponent.form.valid && this.isDirty) || this.canSubmit);
    } else {
      return !this.canSubmit;
    }
  }
}
